import { apiClient } from "../../../api/client";
import * as ActionType from "./setting.type";
import { setToast } from "../../../util/toast";

export const getSetting = () => async (dispatch) => {
  const res = await apiClient.get("setting/getSetting");
  if (res.ok) {
    dispatch({ type: ActionType.GET_SETTING, payload: res.data?.setting });
  } else {
    console.log(res.message);
  }
};

export const updateSetting = (data) => async (dispatch) => {
  const res = await apiClient.patch("setting/updateSetting", data);
  if (res.ok && res.data?.status) {
    dispatch({ type: ActionType.UPDATE_SETTING, payload: res.data?.setting });
    setToast("success", "Setting updated successfully");
  } else {
    setToast("error", res.data?.message || res.message);
  }
};

export const handleToggleSwitch =
  (settingId, field, toggleType) => async (dispatch) => {
    const res = await apiClient.patch("setting/handleToggleSwitch", {
      settingId,
      field,
      toggleType,
    });
    if (res.ok && res.data?.status) {
      dispatch({
        type: ActionType.HANDLE_TOGGLE_SWITCH,
        payload: res.data,
      });
    } else {
      setToast("error", res.data?.message || res.message);
    }
  };

export const handleSellerToggleSwitch =
  (settingId, field, toggleType) => async (dispatch) => {
    const res = await apiClient.patch("setting/handleSellerToggleSwitch", {
      settingId,
      field,
      toggleType,
    });
    if (res.ok && res.data?.status) {
      dispatch({
        type: ActionType.HANDLE_SELLER_TOGGLE_SWITCH,
        payload: res.data,
      });
    } else {
      setToast("error", res.data?.message || res.message);
    }
  };
